import { type ClassValue, clsx } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat().format(num)
}

export function formatDuration(ms: number): string {
  const seconds = Math.floor(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  if (hours > 0) {
    return `${hours}:${(minutes % 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`
  }
  return `${minutes}:${(seconds % 60).toString().padStart(2, '0')}`
}

export function formatPercentage(value: number, decimals = 1): string {
  return `${(value * 100).toFixed(decimals)}%`
}

export function getClassColor(className: string): string {
  const colorMap: Record<string, string> = {
    'death knight': '#C41E3A',
    'demon hunter': '#A330C9',
    druid: '#FF7C0A',
    evoker: '#33937F',
    hunter: '#AAD372',
    mage: '#3FC7EB',
    monk: '#00FF98',
    paladin: '#F48CBA',
    priest: '#FFFFFF',
    rogue: '#FFF468',
    shaman: '#0070DD',
    warlock: '#8788EE',
    warrior: '#C69B6D',
  }
  
  return colorMap[className.toLowerCase()] || '#FFFFFF'
}

export function getDifficultyColor(difficulty: string): string {
  const colorMap: Record<string, string> = {
    'LFR': '#22c55e',
    'Normal': '#3b82f6', 
    'Heroic': '#a855f7',
    'Mythic': '#ef4444',
  }
  
  return colorMap[difficulty] || '#6b7280'
}

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function debounce<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout
  return (...args: Parameters<T>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}